import Svg from '@svg/index';
import { H3 } from '@ui-library/typography';
import React from 'react';
import { BodyText, CTAContainer, EmptyContainer, SvgContainer, TextContainer } from './styles';

interface props {
  headerText: string;
  subText: string;
  cta: JSX.Element | null;
  svgName: string;
  textOnLeft?: boolean;
}

export default ({ headerText, subText, cta, svgName, textOnLeft = false }: props) => (
  <EmptyContainer textLeft={textOnLeft}>
    <SvgContainer>
      <Svg name={svgName} />
    </SvgContainer>
    <TextContainer flexDirection="column">
      <H3>{headerText}</H3>
      <BodyText>{subText}</BodyText>
      <CTAContainer>{cta}</CTAContainer>
    </TextContainer>
  </EmptyContainer>
);
